module.exports = __webpack_public_path__ + "img/Barbier.9723dca0.jpg";